import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

// Material UI
import { withStyles, Paper } from '@material-ui/core';

import AuthUserContainer from '../../containers/AuthUser';
import EnhancedTable from '../../components/table/EnhancedTable';
import FilterHeader from '../../components/table/FilterHeader';
import { getGlobalClasses } from '../../themes';
import Notification from '../../containers/Dispatch/Notification';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
	};
};

class PastNotifications extends Component {
	constructor(props) {
		super(props);
		this.state = {
			order: 'asc',
			orderBy: 'dateCreated',
		};
	}

	componentDidMount() {
		const { notifications, searchNotifications } = this.props;

		console.log('notifications', notifications);
		if (!notifications) {
			searchNotifications({
				params: {},
			});
		} else {
			this.formatNotifications();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { notifications } = this.props;
		if (prevProps.notifications !== notifications) {
			this.formatNotifications();
		}
	}

	handleSnackbarClose = (_event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({ snackbarIsOpen: false });
	};

	formatNotifications = () => {
		//const { classes } = this.props;
		const { notifications, userMap } = this.props;

		const notificationsFormatted = notifications.map((event) => {
			const {
				notificationId,
				senderUserId,
				messageText,
				recipientUserIds,
				notificationType,
				sendStatus,
				statusMessage,
				dateCreated,
			} = event;

			const senderUser = userMap[senderUserId] || { firstName: 'Missing', lastName: '' };

			const recipientUserNames = recipientUserIds.map((userId) => {
				const user = userMap[senderUserId] || { firstName: 'Missing', lastName: '' };
				return `${user.firstName} ${user.lastName}`;
			});

			return {
				key: notificationId,
				senderUserId,
				senderUserDisplay: `${senderUser.firstName} ${senderUser.lastName}`,
				recipientDisplay: recipientUserNames.join(', '),
				messageText,
				notificationType,
				sendStatus,
				statusMessage,
				dateCreated,
				dateCreatedDisplay: moment(dateCreated).format('M/D h:mm a'),
			};
		});

		this.setState({
			notificationsFormatted,
		});
	};

	render() {
		const { classes } = this.props;
		const { notificationsFormatted } = this.state;

		if (!notificationsFormatted) {
			return (
				<div>
					<span style={{ fontSize: 24, padding: 20, fontWeight: 300, color: '#666' }}>
						Fetching past notifications....
					</span>
				</div>
			);
		}

		const columns = [
			{ label: 'Sender', sortId: 'senderUserId', displayId: 'senderUserDisplay' },
			{ label: 'Message', sortId: undefined, displayId: 'messageText' },
			{ label: 'Sender', sortId: undefined, displayId: 'recipientDisplay' },
			{ label: 'Type', sortId: 'typeDisplay', displayId: 'notificationType' },
			{ label: 'Send Status', sortId: 'sendStatus', displayId: 'sendStatus' },
			{ label: 'Status Message', sortId: 'statusMessage', displayId: 'statusMessage' },
			{ label: 'Date', sortId: 'totalDaysSort', displayId: 'dateCreatedDisplay' },
		];

		return (
			<Fragment>
				<FilterHeader
					label={
						<span>
							Past Notifications <span style={{ fontSize: '40%' }}>(last 10 days)</span>
						</span>
					}
					canMakeUpdates={true}
				/>
				<Paper className={classes.globalMainPaper}>
					<EnhancedTable
						rows={notificationsFormatted}
						columns={columns}
						isDense={true}
						defaultOrder={'desc'}
						defaultOrderBy={'dateCreated'}
					/>
				</Paper>
			</Fragment>
		);
	}
}

PastNotifications.propTypes = {
	authUser: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	userMap: PropTypes.object,
	searchNotifications: PropTypes.func.isRequired,
	notifications: PropTypes.array,
};

export default _.flow([withStyles(styles, { withTheme: true }), AuthUserContainer, Notification])(
	PastNotifications
);
